<template>
  <div class="in-lesson-sup-material">
    <!-- 资料列表 -->
    <div class="table-list">
      <div class="title">
        资料列表
      </div>
      <a-table
        :columns="columns"
        :data-source="list"
        row-key="id"
        :pagination="false"
        :scroll="{y: 'calc(100vh - 248px)', x: 415 }"
        :loading="loading"
        :custom-row="customRowFun"
        :row-class-name="rowClassName"
      >
        <span slot="fileName" slot-scope="text, record">
          {{ record.fileName }}
        </span>
        <span slot="fileSize" slot-scope="text, record">
          {{ getSize(record.fileSize) }}
        </span>
        <span slot="operate" slot-scope="text, record">
          <a-button v-if="record.fileSuffix === 'zip' || record.fileSuffix === 'rar'" type="t-link">
            <a :href="`${record.filePath}?attname=${record.fileName + '.' + record.fileSuffix}`">下载</a>
          </a-button>
          <a-button v-else type="t-link" @click="showDetail(record)">下载并打印</a-button>
        </span>
      </a-table>
    </div>
    <!-- 预览区域 -->
    <div class="preview-content">
      <div class="header">
        <div class="title">
          <span>{{ previewInfo.index }}&nbsp;&nbsp;{{ previewInfo.fileName }}</span>
        </div>
        <div class="operate" v-show="previewInfo.viewType === 1 || previewInfo.viewType === 2">
          <a-button>
            <a :href="`${previewInfo.filePath}?attname=${previewInfo.fileName + '.' + previewInfo.fileSuffix}`">下载</a>
          </a-button>
          <a-button type="primary" style="margin-left: 8px">
            <a v-if="previewInfo.viewType === 1" @click="printImg(previewInfo.filePath)">打印</a>
            <a v-if="previewInfo.viewType === 2" @click="printPdf(previewInfo.filePath)">打印</a>
          </a-button>
        </div>
      </div>
      <div class="preview">
        <a-spin v-show="imgLoad.loading" class="img-loading" :tip="imgLoad.percent + '%'" />
        <img
          v-if="previewInfo.viewType === 1 && previewInfo.filePath4Local"
          :src="previewInfo.filePath4Local"
        />
        <iframe
          v-if="previewInfo.viewType === 2"
          :src="previewInfo.filePath + '#toolbar=0'"
          frameborder="0"
          width="100%"
          height="100%"
          border="0"
        />
        <div v-if="previewInfo.viewType === 3" class="empty">
          请先选择左侧资料
        </div>
      </div>
    </div>
  </div>
</template>
<script>

import columns from './columns'
import service from '@/service/correction'
import { throttle } from 'lodash'

export default {
  props: {
    classTypeId: {
      type: Number,
      default: () => -1
    },
    lessonId: {
      type: Number,
      default: () => -1
    }
  },
  data() {
    return {
      columns,
      loading: false,
      list: [],
      previewInfo: {
        index: undefined,
        viewType: 3,
        filePath: undefined,
        filePath4Local: undefined
      },
      imgLoad: {
        percent: '0',
        loading: false
      },
      selectedIndexId: -1,
      dpi: -1
    }
  },
  created() {
    this.getList()
    this.dpi = this.getDpi()
  },
  methods: {
    async getList() {
      this.loading = true
      const { classTypeId, lessonId } = this
      const list = await service.getSupMaterial({ classTypeId, lessonId })
      list.forEach((item, index) => (item.index = index + 1))
      this.list = list
      this.loading = false
    },
    showDetail(record) {
      this.selectedIndexId = record.index
      this.previewInfo.viewType = record.fileSuffix === 'pdf' ? 2 : 1
      this.previewInfo = { ...this.previewInfo, ...record }
      if (this.previewInfo.viewType === 1) { // 图片预览
        this.previewInfo.filePath4Local = undefined
        if (this.xhr) {
          this.xhr.abort()
        }
        this.imgLoad.loading = true
        this.myDownload(record)
      }
    },
    getDpi() {
      for (var i = 56; i < 2000; i++) {
        if (matchMedia(`(max-resolution: ${i}dpi)`).matches === true) {
          return i
        }
      }
    },
    generateIframe(url) {
      const iframe = document.createElement('iframe')
      iframe.setAttribute('class', 'in-lesson-sup-material-preview')
      // iframe 不展示在页面
      iframe.style.height = 0
      iframe.style.visibility = 'hidden'
      iframe.style.width = 0
      // 设置 iframe 内容
      iframe.setAttribute('srcdoc', '<html><body></body></html>')
      document.body.appendChild(iframe)

      iframe.addEventListener('load', () => {
        // 生成图片元素
        const div = parseDom(`<div style="display:flex;justify-content: center;align-items:flex-start;height:${297 * (this.dpi / 25.4) - 110}px;"><img style="width: 100%;height: 100%;object-fit: contain;" src="${url}"/></div>`)[0]
        // 把图片元素添加到 iframe 内
        const body = iframe.contentDocument.body
        body.appendChild(div)
        const image = div.getElementsByTagName('img')[0]
        image.addEventListener('load', function () {
          iframe.contentWindow.print()
        })
      })

      const parseDom = arg => {
        const objE = document.createElement('div')
        objE.innerHTML = arg
        return objE.childNodes
      }
    },
    printImg(url) {
      this.generateIframe(url)
    },
    printPdf(filePath) {
      const print = newUrl => {
        const iframe = document.createElement('IFRAME')
        iframe.setAttribute('class', 'in-lesson-sup-material-preview')
        iframe.src = newUrl
        document.body.appendChild(iframe)
        iframe.contentWindow.focus()
        iframe.contentWindow.print()
      }
      // 下载资源
      const url = filePath
      const xhr = new XMLHttpRequest()
      xhr.open('GET', url, true) // 异步
      xhr.responseType = 'blob' // blob 类型
      xhr.onload = () => {
        if (xhr.status != 200) {
          this.$message.error('下载异常！')
          return
        }
        print(window.URL.createObjectURL(xhr.response))
      }
      xhr.send()
    },
    getSize(size) {
      return Math.round(size / (1024 * 1024) * 100) / 100 + 'M'
    },
    customRowFun(record) {
      return {
        on: {
          click: evt => {
            if (this.previewInfo.index === record.index) {
              return
            }
            const { fileSuffix } = record
            if (fileSuffix === 'zip' || fileSuffix === 'rar') {
              return
            }
            this.showDetail(record)
          }
        }
      }
    },
    rowClassName({ index }) {
      return this.selectedIndexId === index ? 'selected-row-sm' : ''
    },
    myDownload(record) {
      const xhr = new XMLHttpRequest()
      this.xhr = xhr
      xhr.open('GET', record.filePath, true)
      xhr.responseType = 'blob'
      xhr.onload = () => {
        if (xhr.status != 200) {
          this.$message.error('下载异常！')
          return
        }
        this.imgLoad.loading = false
        if (this.previewInfo.index === record.index) {
          this.previewInfo.filePath4Local = window.URL.createObjectURL(xhr.response)
        }
      }
      xhr.onprogress = throttle(({ loaded, total }) => {
        this.imgLoad.percent = Math.round(loaded / total * 100)
      }, 200)
      xhr.send()
    }
  },
  beforeDestroy() {
    const list = document.querySelectorAll('.in-lesson-sup-material-preview')
    if (list.length) {
      const parent = list[0].parentElement
      list.forEach(item => parent.removeChild(item))
    }
    this.xhr && this.xhr.abort()
  }
}
</script>
<style scoped lang="less">
@import '~@/static/css/base.less';
:deep(.ant-table-wrapper .ant-table .ant-table-tbody>tr>td) {
    padding-left: 8px !important;
    padding-right: 16px !important;
  }
.in-lesson-sup-material {
  display: flex;
  height: 100%;

  .table-list {
    width: 50%;
    min-width: 400px;
    padding: 20px;
    border-right: 1px solid #EBEDF0;

    .title {
      font-weight: 700;
      font-size: 16px;
      line-height: 22px;
      color: #505873;
      padding-bottom: 12px;
    }

    :deep(.ant-table-row) {
      > td {
      border-top: 1px solid #fff;
      border-bottom: 1px solid #EBEDF0;
    }
    > td:nth-child(1) {
      border-left: 1px solid #fff;
    }
    > td:last-child {
      border-right: 1px solid #fff;
    }
    }
  }

  .preview-content {
    flex: 1;
    padding: 20px;
    .header {
      display: flex;
      justify-content: space-between;
      padding-bottom: 12px;
    }
    .title {
      font-weight: 700;
      font-size: 16px;
      line-height: 32px;
      color: #505873;
      flex: 1;
      width: 0;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      vertical-align: bottom;
      padding-right: 10px;
    }

    .operate .ant-btn-two-chinese-chars {
        color: #3262FD;
        border-color: #3262FD;
    }

    .preview {
      display: flex;
      justify-content: center;
      align-items: center;
      height: calc(100% - 44px);
      background: #F0F2F4;
      border-radius: 8px;
      position: relative;

      >img {
        width: 100%;
        height: 100%;
        object-fit: contain;
      }
      .empty {
        font-size: 14px;
        line-height: 22px;
        color: #70788C;
      }
      .img-loading {
        position: absolute;
        left: 50%;
        top:50%;
        transform: translate(-50%, -50%);
      }

    }
  }
  // :deep(.ant-table-header.ant-table-hide-scrollbar) {
  //   margin-right: -15px;
  // }
  :deep(.selected-row-sm) {
    > td {
      border-top: 1px solid #3262fd !important;
      border-bottom: 1px solid #3262fd !important;
    }
    > td:nth-child(1) {
      border-left: 1px solid #3262fd !important;
    }
    > td:last-child {
      border-right: 1px solid #3262fd !important;
    }
    tr {
      border: 1px solid #000;
    }
  }
  :deep(.ant-table-fixed-right) {
    height: 100%;
  }
}
</style>
